import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/echarts.js'
import i18n from './i18n'
import './assets/css/global.css'
import './assets/bigreport/style.scss'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import axios from 'axios'
import 'font-awesome/css/font-awesome.css'
import Any from '@/components/form/Any.js'
import mhPlugins from '@/components/base/mhPlugins.js'
import jsPlumb from 'jsplumb'
import './plugins/codemirror'
import dataV from '@jiaminghi/data-view'
import VueParticles from 'vue-particles'
import vGanttChart from 'v-gantt-chart'
import Vue2OrgTree from 'vue2-org-tree'
// import { showLoading, hideLoading } from '@/assets/js/loading'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.interceptors.request.use(config => {
  config.headers.token = window.sessionStorage.getItem('token')
  // showLoading()
  return config
})
// axios.interceptors.response.use((res) => {
//   // hideLoading()
//   return res
// }, (err) => {
//   // hideLoading()
//   Vue.$alert(err.response.status, '提示', {
//     confirmButtonText: '确定'
//   })
//   return Promise.reject(err)
// })
Vue.prototype.$http = axios
Vue.prototype.$Any = Any
Vue.use(mhPlugins)
Vue.use(dataV)
Vue.use(VueParticles)
Vue.component('icon', Icon)
Vue.config.productionTip = false
Vue.prototype.$jsPlumb = jsPlumb.jsPlumb
Vue.use(vGanttChart)
Vue.use(Vue2OrgTree)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
